import React, { useState, useEffect } from "react";
import "./InvoicePDFTemplate.scss";
import { getMyClientsByID } from "../../services/api/MyClientsApi";

export const InvoicePDFTemplate = ({ invoice, settings, isSystemInvoice = false, companyDetails = null }) => {
    console.log(settings, "setttttt")
    console.log(invoice, "invoiceeeee")
    console.log(isSystemInvoice, "isSystemInvoice")
    console.log(companyDetails, "companyDetails")

    const [clientDetails, setClientDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    const {
        headerText,
        header,
        footer,
        displayHeaderFooter,
        displayBankDetails,
        bankDetails,
        isSignatureDigitalGenerated,
        digitalSignature,
        displayTermsAndConditions,
        termsAndConditions,
        gstNo,
        panNo,
        address,
    } = settings;

    // Updated getDisplayUrl function to handle data URLs
    const getDisplayUrl = (url) => {
        if (!url) return "";
        // Handle data URLs (base64 encoded images)
        if (url.startsWith('data:')) return url;
        // Handle full URLs
        if (url.startsWith('http')) return url;
        // Handle static assets
        if (url.startsWith('/static/') || url.startsWith('/assets/')) return url;
        // Backend paths
        return `${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${url}`;
    };

    // Fetch client details when component mounts - ONLY for regular invoices
    useEffect(() => {
        const fetchClientDetails = async () => {
            // Skip fetching client details for system invoices
            if (isSystemInvoice) {
                return;
            }

            if (invoice.issuedTo) {
                setLoading(true);
                try {
                    const response = await getMyClientsByID(invoice.issuedTo);
                    setClientDetails(response.data);
                } catch (error) {
                    console.error("Error fetching client details:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchClientDetails();
    }, [invoice.issuedTo, isSystemInvoice]);

    return (
        <div className="invoice-pdf">
            {displayHeaderFooter ? (
                header ? (
                    <img src={getDisplayUrl(header)} alt="Header" className="invoice-header" />
                ) : (
                    <p>Header not available</p>
                )
            ) : (
                <h2 className="company-name">{headerText}</h2>
            )}

            <div className="invoice-details-container req-pad">
                <div className="invoice-info">
                    <p><strong>Invoice No:</strong> {invoice.invoiceNumber}</p>
                    <p><strong>Date:</strong> {new Date(invoice.createdAt).toLocaleDateString()}</p>
                    {/* {gstNo && <p><strong>GST No:</strong> {gstNo}</p>}
                    {panNo && <p><strong>PAN No:</strong> {panNo}</p>} */}
                    {/* Only show address for regular invoices, not system invoices */}
                    {!isSystemInvoice && address && <p><strong>Address:</strong> {address}</p>}
                </div>

                <div className="client-info">
                    {isSystemInvoice ? (
                        // Display company details for system invoices
                        companyDetails ? (
                            <>
                                <p><strong>Company:</strong> {companyDetails.companyName}</p>
                                {companyDetails.gstin && <p><strong>GST No:</strong> {companyDetails.gstin}</p>}
                                <p><strong>Address:</strong> {companyDetails.address}</p>
                                {companyDetails.city && <p>{companyDetails.city}, {companyDetails.state} - {companyDetails.zip}</p>}
                                {companyDetails.country && <p>{companyDetails.country}</p>}
                                {companyDetails.email && <p><strong>Email:</strong> {companyDetails.email}</p>}
                                {companyDetails.phone && <p><strong>Phone:</strong> {companyDetails.phone}</p>}
                            </>
                        ) : (
                            <p>Company details not available</p>
                        )
                    ) : (
                        // Display client details for regular invoices
                        loading ? (
                            <p>Loading client details...</p>
                        ) : clientDetails ? (
                            <>
                                <p><strong>Name:</strong> {clientDetails.salutation} {clientDetails.name}</p>
                                <p><strong>Company:</strong> {clientDetails.company}</p>
                                {clientDetails.gstin && <p><strong>GST No:</strong> {clientDetails.gstin}</p>}
                                <p><strong>Address:</strong> {clientDetails.addressLine1}</p>
                                {clientDetails.addressLine2 && <p>{clientDetails.addressLine2}</p>}
                                <p>{clientDetails.city}, {clientDetails.state} - {clientDetails.zipcode}</p>
                                <p>{clientDetails.country}</p>
                            </>
                        ) : (
                            <p>Client details not available</p>
                        )
                    )}
                </div>
            </div>

            <table className="invoice-table req-pad">
                <thead>
                    <tr>
                        <th>Description</th>
                        <th>Qty</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {invoice.items.map((item, i) => (
                        <tr key={i}>
                            <td>{item.description || item.name}</td>
                            <td>{item.qty || item.quantity || 1}</td>
                            <td>₹{item.amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <table className="breakdown-table req-pad">
                <tbody>
                    <tr>
                        <td></td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>TOTAL</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            Rs. {(invoice.subtotal || invoice.totalAmount).toFixed(2)}
                        </td>
                    </tr>

                    {/* Show GST details if GST number exists OR if invoice has GST amounts */}
                    {(gstNo || invoice.sgstAmount > 0 || invoice.cgstAmount > 0 || invoice.igstAmount > 0) && (
                        <>
                            {invoice.sgstPercentage > 0 && invoice.sgstAmount > 0 && (
                                <tr>
                                    <td></td>
                                    <td style={{ textAlign: 'right' }}>SGST @ {invoice.sgstPercentage}%</td>
                                    <td style={{ textAlign: 'right' }}>Rs. {invoice.sgstAmount.toFixed(2)}</td>
                                </tr>
                            )}

                            {invoice.cgstPercentage > 0 && invoice.cgstAmount > 0 && (
                                <tr>
                                    <td></td>
                                    <td style={{ textAlign: 'right' }}>CGST @ {invoice.cgstPercentage}%</td>
                                    <td style={{ textAlign: 'right' }}>Rs. {invoice.cgstAmount.toFixed(2)}</td>
                                </tr>
                            )}

                            {invoice.igstPercentage > 0 && invoice.igstAmount > 0 && (
                                <tr>
                                    <td></td>
                                    <td style={{ textAlign: 'right' }}>IGST @ {invoice.igstPercentage}%</td>
                                    <td style={{ textAlign: 'right' }}>Rs. {invoice.igstAmount.toFixed(2)}</td>
                                </tr>
                            )}
                        </>
                    )}
                    
                    <tr style={{ backgroundColor: '#004A9A', color: 'white' }}>
                        <td></td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold', color: 'white' }}>PAYABLE AMOUNT</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold', color: 'white' }}>
                            Rs. {invoice.totalAmount.toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>

            {displayBankDetails && bankDetails && (
                <div className="bank-details req-pad">
                    <strong>Bank Details:</strong>
                    <p>{bankDetails}</p>
                </div>
            )}

            {displayTermsAndConditions && termsAndConditions && (
                <div className="terms req-pad">
                    <strong>Terms & Conditions:</strong>
                    {termsAndConditions.split(/\d+\)\s?/).filter(Boolean).map((rule, idx) => (
                        <p key={idx}>{`${idx + 1}) ${rule}`}</p>
                    ))}
                </div>
            )}

            <div className="signature req-pad">
                {isSignatureDigitalGenerated && digitalSignature ? (
                    <img src={getDisplayUrl(digitalSignature)} alt="Digital Signature" className="signature-image" />
                ) : (
                    <p>This is a system-generated invoice</p>
                )}
            </div>

            {displayHeaderFooter && footer && (
                <img src={getDisplayUrl(footer)} alt="Footer" className="invoice-footer" />
            )}
        </div>
    );
};